export default {
    updateOpportunity(id, data) {
        return ApiClient.put(`/opportunities/${id}`, {}, data);
    },
};
